import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchdatasss = (datass: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: datass,
});
export const fetchdatassss = (datasss: any) => ({
    type: 'FETCH_DATA2_SUCCESS',
    payload: datasss,
});
// export const fetchname = (name: any) => ({
//     type: 'FETCH_NAME_SUCCESS',
//     payload: name,
// });
// export const fetchCountries = (country: any) => ({
//     type: 'FETCH_COUN_SUCCESS',
//     payload: country,
// });
// export const updateDoctors = (edit: any) => ({
//     type: 'FETCH_EDIT_SUCCESS',
//     payload: edit,
// });
export const removeData = (remove: any) => ({
    type: 'FETCH_REMOVE_SUCCESS',
    payload: remove,
});
export const fetchDoctorDrop = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,uid:uid};
            const apiname = SUPRIVISOR_API.slinkass;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAssistantDrop = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid,q:4};
            const apiname = SUPRIVISOR_API.slinkass;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasss(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,uid:uid};
            const apiname = SUPRIVISOR_API.slinkass;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatassss(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const DeleteAssistant = (ID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {lid:ID,q:5};
            const apiname = SUPRIVISOR_API.slinkass;
            const response = await LoginService.getData(apiname,payload);
            dispatch(removeData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//         try {
//             const payload = {special:SpecilityName,q:8};
//             const apiname = SUPRIVISOR_API.sdashboard;
//             const response = await LoginService.getData(apiname,payload);
//             dispatch(fetchdatasss(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };
// export const getCountries = () => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = {};
//             const apiname = SUPRIVISOR_API.countrydata;
//             const response = await LoginService.getData(apiname,payload);
//             dispatch(fetchCountries(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };
// export const editDoctors = (FirstName:any,lastName:any,Email:any,Phone:any,CoountryID:any,SpecilityName:any,uid:any) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = {fname:FirstName,lname:lastName,email:Email,phone:Phone,country:CoountryID,specid:SpecilityName,did:uid,q:3};
//             const apiname = SUPRIVISOR_API.sdoctorget;
//             const response = await LoginService.getData(apiname,payload);
//             dispatch(updateDoctors(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };
// export const DeleteDoctor = (id:any) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = {did:id,q:4};
//             const apiname = SUPRIVISOR_API.sdoctorget;
//             const response = await LoginService.getData(apiname,payload);
//             dispatch(removeData(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };